import React, { ComponentType, FC } from 'react'
import { overwriteHocDisplayName } from '../../lib/hoc/overwriteHocDisplayName'
import StepTreePathProvider from './StepTreePathProvider'

type Config<WrappedComponentProps> = {
  getLatestLinkFromProps(wrappedProps: WrappedComponentProps): string
}

export const withStepTreePath = <Props extends Object>(
  WrappedComponent: ComponentType<Props>,
  config: Config<Props>
) => {
  const OuterComponent: FC<Props> = props => {
    const newTreePathLink = config.getLatestLinkFromProps(props)

    return (
      <StepTreePathProvider newestPathLink={newTreePathLink}>
        <WrappedComponent {...props} />
      </StepTreePathProvider>
    )
  }

  overwriteHocDisplayName(WrappedComponent, OuterComponent, 'withStepTreePath')

  return OuterComponent
}
